import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=48ba972d&scoped=true"
import script from "./InputText.vue?vue&type=script&lang=js"
export * from "./InputText.vue?vue&type=script&lang=js"
import style0 from "./InputText.vue?vue&type=style&index=0&id=48ba972d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba972d",
  null
  
)

export default component.exports